export default __webpack_public_path__ + "static/media/logo.4a9924f7.png";